<template>
  <section id="top">
    <h1>
      How Much Revenue Do the
      <span class="highlight">World’s Wealthiest Football Clubs</span>
      Generate?
    </h1>

    <p>
      Have you ever wondered how much money the biggest football clubs in the
      world are earning? With TV income, matchday receipts, lucrative
      sponsorships, and official merchandise to sell, the team at NetBet
      analysed the past 24 months of earnings reports to find out who’s got the
      healthiest balance sheets.

      <br /><br />These are the results…
    </p>
  </section>
</template>


<style lang="scss" scoped>
h1 {
  @include respond(phone-only) {
    font-size: 40px;
  }
}
.highlight {
  color: $highlight1;
}

p {
  margin: 60px 0px 0px 0px;
}

section {
  padding: 0px 20px 0px 20px;
}
</style>